import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function RecentArticles() {
  const recentArticles = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-600 text-sm">
              最新的免费91网页使用指南和更新动态
            </p>
          </div>
          <Link
            to="/category/latest-news"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {recentArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block rounded-lg overflow-hidden border border-background-200/70 bg-background-50 hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime} 分钟阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/latest-news"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}